import { dataProps } from './properties'

export const setCommunicationTemplateList = (state, payload) => {
    state.list = payload
}    

export const setCommunicationTemplateData = (state, payload) => {
    state.props = payload
} 

export const resetCommunicationTemplateData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/communicationTemplate/mutations.js